import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  CircularProgress,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Container
} from "@material-ui/core";
import { CommonStyles } from "../../commons/CommonStyles";
import { UserCancelAccountStyles } from "./UserCancelAccountStyles";
import {
  PostUtilitiesCorreosIdCancelAccount,
} from "../../services/UtilitiesCallsService";
import {
  GetUtilitiesCorreosIdSubscriptionUserTycPrivacyUrls,
} from "../../services/UtilitiesCallsService";
import { CorreosButton } from "../CorreosButton/CorreosButton";
import { backToLogin } from "../../services/Commons";
import { checkIsNullUndefined, getErrorMessage } from "../../commons/Utils";
import { useTranslation } from "react-i18next";
import { Alerts } from "../Alerts/Alerts";
import { BasicDialog } from "../CommonComponents/BasicDialog";
import { GetLegalRGPD } from "../../services/LegalCallsService";
import { GetMasterRgpd } from "../../services/MasterCallsService";
import { isResultOk, showAlert } from "../../commons/FormManager";
import { SwitchYesNoButton } from "../CommonComponents/SwitchYesNoButton/SwitchYesNoButton";

export function UserCancelAccount(props) {
  const {
    enterpriseList,
  } = props;
  const commonClasses = CommonStyles();
  const classes = UserCancelAccountStyles();
  const { t } = useTranslation();

  const [userEnterpriseList, setUserEnterpriseList] = useState([]);
  const [circularProgress, setCircularProgress] = useState(true);
  const [
    circularProgressCancelingAccount,
    setCircularProgressCancelingAccount,
  ] = useState(false);
  const [userSubscriptions, setUserSubcriptions] = useState([]);
  const [alert, setAlert] = useState({
    open: false,
    color: "",
    message: "",
  });
  const [openPopup, setOpenPopup] = useState(false);
  const [userRgpd, setUserRgpd] = useState([]);

  useEffect(() => {
    let auxTitularList = enterpriseList.filter(ent => ent.isTitular && !ent.isOrganization);
    if (auxTitularList.length > 0) {
      setUserEnterpriseList(auxTitularList);
    };
    getUserRgpd();
  }, [enterpriseList]);

  useEffect(() => {
    getUserRgpd();
  }, []);

  const finishOperation = (color, message) => {
    setAlert({
      open: true,
      color,
      message,
    });
  };

  const getUserRgpd = () => {
    setCircularProgress(true);
    Promise.all([GetMasterRgpd(), GetLegalRGPD(), GetUtilitiesCorreosIdSubscriptionUserTycPrivacyUrls()]).then((results) => {
      let materRgpd = results[0];
      let legalRgpd = results[1];
      let auxUserSubscriptions = results[2];
      if (isResultOk([materRgpd, legalRgpd, auxUserSubscriptions])) {
        let auxUserRgpds = JSON.parse(JSON.stringify(materRgpd));
        auxUserRgpds.forEach((elem) => {
          let auxiliarRgpd = legalRgpd.find((rgpd) => rgpd.idRgpd == elem.id);
          elem.checked = !checkIsNullUndefined(auxiliarRgpd);
        });
        setUserRgpd(auxUserRgpds);
        setUserSubcriptions(auxUserSubscriptions);
        setCircularProgress(false);
      } else {
        showAlert([materRgpd, legalRgpd, auxUserSubscriptions], finishOperation, t);
        setCircularProgress(false);
      }
    });
  };

  const handleSend = () => {
    setOpenPopup(true);
  };

  const confirmCancelAccount = () => {
    setCircularProgressCancelingAccount(true);
    PostUtilitiesCorreosIdCancelAccount().then((response) => {
      if (response && !response.Status) {
        backToLogin();
      } else {
        finishOperation("error", getErrorMessage(response, t));
        setCircularProgressCancelingAccount(false);
      }
    });
  };

  const changeRgpd = (idRgpd, value) => {
    let auxUserRgpd = JSON.parse(JSON.stringify(userRgpd));
    let auxRgpd = auxUserRgpd.find((rgpd) => rgpd.id === idRgpd);
    auxRgpd.checked = value;
    setUserRgpd(auxUserRgpd);
  };

  const checkAllChecked = () => {
    let allChecked = userRgpd.every((rgpd) => rgpd.checked);
    return allChecked;
  };

  const checkNoneChecked = () => {
    let noneChecked = userRgpd.every((rgpd) => !rgpd.checked);
    return noneChecked;
  };

  const manageAllChecks = (check) => {
    setUserRgpd((prev) =>
      prev.map((rgpd) => ({ ...rgpd, checked: check }))
    );
  };

  return (
    <Grid>
      <Alerts alert={alert} setAlert={setAlert}></Alerts>
      <BasicDialog
        open={openPopup}
        setOpen={setOpenPopup}
        title={t("warning")}
        text={t("accountCancelDisableAccountLastWarn")}
        action={confirmCancelAccount}
      />
      <Grid>
        {circularProgress ? (<CircularProgress />) :
          <Grid container>
            <Grid style={{ marginTop: "1.5em" }}>
              <Typography
                variant="h6"
                className={commonClasses.title}
                style={{ textAlign: "left", marginTop: "1em" }}
              >
                {t("accountCancelDisableAccountTitle")}
              </Typography>
              <Typography
                className={commonClasses.textDiv}
                style={{ textAlign: "left" }}
              >
                <ul>
                  {userSubscriptions.map((app) => (
                    <li>{app.application}</li>
                  ))}
                </ul>
                <Typography
                  variant="h6"
                  className={commonClasses.title}
                  style={{ textAlign: "left" }}
                >
                  {t("accountCancelDisableAccountListTitle")}
                </Typography>
                <ul>
                  <li>{t("accountCancelDisableAccountList")}</li>
                  {userEnterpriseList.length > 0 ? (
                    <li>
                      {t("accountCancelDisableAccountListEnterprise")}
                      <ul>
                        {userEnterpriseList.map((ent) => (
                          <li>{ent.name}</li>
                        ))}
                      </ul>
                    </li>
                  ) : null}
                </ul>
                <p>{t("accountCancelDisableAccountP1")}</p>
              </Typography>
            </Grid>
            <Grid container spacing={1} alignItems="flex-end">
              <Grid item xs={12} md={6} style={{ display: "flex", textAlign: "left" }}>
                {/* <CorreosIcon iconSelected={iconNames.privacy} iconName="Status Icon" iconState="basic" iconScale={3} /> */}
                <Typography variant="h6" className={commonClasses.title} style={{ textAlign: "left" }}>
                  {t("accountCancelDisableAccountRGPDWarn")}
                </Typography>
              </Grid>
              <Grid container item xs={12} md={6} justifyContent="flex-end" style={{ display: "flex" }}>
                <FormControl>
                  <FormGroup row>
                    <FormControlLabel
                      value="end"
                      control={<Checkbox color="primary" onClick={() => manageAllChecks(true)} checked={checkAllChecked()} size="small" />}
                      label={<Typography >{t("privacyEnableAllText")}</Typography>}
                      labelPlacement="end"
                      style={{ margin: "auto 1em auto auto" }}
                    />
                    <FormControlLabel
                      value="end"
                      control={<Checkbox color="primary" onClick={() => manageAllChecks(false)} checked={checkNoneChecked()} size="small" />}
                      label={<Typography >{t("privacyDisableAllText")}</Typography>}
                      labelPlacement="end"
                      style={{ margin: "auto 0em auto auto" }}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
              <Container className={classes.switches}>
                <Grid container spacing={1}>
                  {userRgpd.map((element, index) => {
                    return (
                      <Grid container item xs={12} key={index} className={index % 2 == 0 ? commonClasses.evenRow : commonClasses.oddRow}>
                        <Grid item xs={8} sm={10} style={{ display: "flex" }}>
                          <Typography style={{ float: "left", margin: "auto auto auto 1em" }}>
                            {element.name}
                          </Typography>
                        </Grid>
                        <Grid item xs={4} sm={2} style={{ textAlign: "right", paddingLeft: "1em", paddingRight: "0.5em", height: "4em" }}>
                          <SwitchYesNoButton checked={element.checked} code={element.id} handleSwitchButtons={changeRgpd} disabled={false} />
                        </Grid>
                      </Grid>
                    )
                  })}
                </Grid>
              </Container>
            </Grid>
            <Grid
              container
              item
              spacing={1}
              xs={12}
              className={commonClasses.dialogButtonContainer}
            >
              <Grid item xs={12} style={{ textAlign: "center" }}>
                <CorreosButton
                  color="secondary"
                  onClick={() => {
                    handleSend();
                  }}
                  circularProgress={circularProgressCancelingAccount}
                >
                  {t("accountCancelDisableAccountConfirm")}
                </CorreosButton>
              </Grid>
            </Grid>
          </Grid>
        }
      </Grid>
    </Grid>
  );
}
